import { gql } from '@src/__generated__';

export const UPDATE_PROPERTY = gql(/* GraphQL */`
  mutation updateProperty($input: UpdateObjectPropertyInput!) {
    updateObjectProperty(input: $input) {
      clientMutationId
    }
  }
`);
